module.exports = __webpack_public_path__ + "assets1752042029796/img/error-401.98bba5b1.svg";